// The 9-day rota structure
export const ROTA_DAYS = [
  'Friday (Arrivals)',
  'Saturday (Arrivals)',
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday (Departures)',
  'Saturday (Departures)',
];

export const PERIODS = ['Meeting', 'Morning', 'Afternoon', 'Evening', 'Night'];
